 <!-- saved search -->
 <p-dialog header="{{ headerTitle }}" [(visible)]="displaySavedSearchRule" (onHide)="dialogClose()" [modal]="true" [responsive]="true" [closable]="false" [style]="{width: '50vw'}">
   <div class="card">
       <div class="p-grid">
           <div class="p-col-12" style="display: relative;">
               <label>Saved Search</label>
               <span class="p-buttonset p-d-flex w-100">
                   <button pButton pRipple label="{{selectedSSName}}" class="p-button-outlined ddBtn w-100"
                   (click)="op.toggle($event)"></button>
                   <button pButton pRipple icon="pi pi-angle-down" (click)="op.toggle($event)"></button>
               </span>
               <p-overlayPanel #op styleClass="panel-in-dialog dd-panel">
                   <ng-template pTemplate>

                        <div class="p-grid full-width-from">
                            <div class="p-col-4">
                                <label>Module</label>
                                <p-dropdown appendTo="body" [options]="parentModules" [(ngModel)]="selectedParentModule"
                                    optionLabel="name" dataKey="id" placeholder="Select Module" [filter]="true"
                                    [resetFilterOnHide]="true" (onChange)="onChangeParentModule()" [disabled]="!moduleSelection">
                                </p-dropdown>
                            </div>
                            <div class="p-col-4">
                                <label>Channel</label>
                                <p-dropdown appendTo="body" [options]="parentTemplates" [(ngModel)]="selectedParentTemplate"
                                    optionLabel="channelName" dataKey="id" placeholder="Select Channel" [filter]="true"
                                    [resetFilterOnHide]="true" (onChange)="onChangeParentChannel()" [disabled]="!moduleSelection">
                                </p-dropdown>
                            </div>
                            <div class="p-col-4">
                                <label>Search by Name</label>
                                <span class="p-input-icon-left w-100">
                                    <i class="pi pi-search"></i>
                                    <input class="w-100" pInputText type="text" [formControl]="searchControl" placeholder="Search..." />
                                </span>
                            </div>
                        </div>

                       <p-table #workflow [columns]="listCols" [value]="savedSearchesList" [paginator]="true"
                       [style]="{width:'100%'}" [rows]="pageSize" [lazy]="true" [(first)]="first"
                       [totalRecords]="totalRecords" (onLazyLoad)="getSavedSearchListByFilter($event)"
                       selectionMode="single" [(selection)]="selectedSearch" dataKey="id" responsiveLayout="scroll"
                       (onRowSelect)="onRowSelect($eventd)" (onRowUnselect)="onRowUnselect()" scrollHeight="20rem"
                       [showCurrentPageReport]="true"
                       currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="tableShowMore">
                           <ng-template pTemplate="colgroup" let-columns>
                               <colgroup>
                                   <ng-container *ngFor="let col of columns">
                                       <col *ngIf="col.show" style="width:auto">
                                   </ng-container>
                               </colgroup>
                           </ng-template>
                           <ng-template pTemplate="header" let-columns>
                               <tr>
                                   <ng-container *ngFor="let col of columns">
                                       <th *ngIf="col.show" [pSortableColumn]="col.field">
                                           {{col.header}}
                                           <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
                                           </p-sortIcon>
                                           <span *ngIf="col.order" class="pi pi-filter p-ml-2 filtericon" [ngClass]="{'blink_me' : col.value.length > 0}" (click)="$event.stopPropagation(); curCol = col; filter.toggle($event)">
                                           </span>
                                       </th>
                                   </ng-container>
                               </tr>
                           </ng-template>
                           <ng-template pTemplate="body" let-rowData let-columns="columns">
                               <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
                                   <ng-container *ngFor="let col of columns">
                                       <td *ngIf="col.show" style="text-align: left;">
                                           <ng-container [ngSwitch]="col?.dataType">
                                               <ng-container *ngSwitchCase="'date'">
                                                   <div>
                                                       {{ rowData[col.field] | date:'MM/dd/yyyy' }}
                                                   </div>
                                               </ng-container>
                                               <ng-container *ngSwitchDefault>
                                                   <div>
                                                       {{ rowData[col.field] }}
                                                   </div>
                                               </ng-container>
                                           </ng-container>
                                       </td>
                                   </ng-container>
                               </tr>
                           </ng-template>
                           <ng-template pTemplate="emptymessage">
                               <tr>
                                   <td colspan="6">{{noSearchesFindOrLoadingText}}</td>
                               </tr>
                           </ng-template>
                       </p-table>
                       <p-overlayPanel #filter [showCloseIcon]="false" [dismissable]="true">
                           <ng-template pTemplate>
                               <input pInputText type="text" #inputS [(ngModel)]="curCol.value"
                                   (input)="workflow.filter(curCol.value, curCol.field, 'contains')"
                                   placeholder="Search by {{curCol.header}}" class="p-column-filter"
                                   [value]="workflow.filters[curCol.field] ? workflow.filters[curCol.field].value : ''">
                           </ng-template>
                       </p-overlayPanel>
                   </ng-template>
               </p-overlayPanel>
           </div>
       </div>
       <div class="p-grid" *ngIf="selectedSearch?.savedSearchRuleRequest?.length > 0">
           <div class="p-col-12">
               <div class="header">
                   <h5>Rules</h5>
               </div>
               <p-table [value]="selectedSearch?.savedSearchRuleRequest" responsiveLayout="scroll">
                    <ng-template pTemplate="header" let-rule>
                        <tr>
                            <th style="width: 100px;">Rule No.</th>
                            <th>Choice</th>
                            <th>Filter</th>
                            <th>Operator</th>
                            <th style="max-width: 300px;">Value</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rule let-index="rowIndex">
                        <tr>
                            <td style="width: 100px;">#{{index + 1}}</td>
                            <td>{{rule.operator}}</td>
                            <td>
                                <span *ngIf="rule.objectName !== null">{{rule.objectName}}</span>
                                <span
                                    *ngIf="rule.templateName !== null">({{rule.templateName}})</span>
                                <span *ngIf="rule.objectName !== null">: </span> {{ rule?.parentLabelName ? rule?.parentLabelName + ': ' : '' }}{{rule.labelName}}
                            </td>
                            <td>{{rule.equation}}</td>
                            <td style="max-width: 300px;">
                                <ng-container *ngIf="rule?.valuesJson">
                                    <ng-container *ngIf="rule?.criteria?.toLowerCase() == 'radius'">
                                        Address: {{rule?.valuesJson?.address}}, Radius:
                                        {{rule?.valuesJson?.radius}} {{rule?.valuesJson?.radius > 2
                                        ? 'miles':'mile'}}
                                    </ng-container>
                                    <ng-container
                                        *ngIf="rule?.criteria?.toLowerCase() == 'territoryname'">
                                        Parent: {{rule?.valuesJson?.country}}, Name:
                                        {{rule?.valuesJson?.name}}
                                    </ng-container>
                                    <!-- <ng-container *ngIf="rule?.criteria?.toLowerCase() != 'territoryname'">
                                        <ng-container *ngFor="let val of rule?.valuesJson">
                                            Parent: {{val?.country}}, Child: {{val?.name}}
                                        </ng-container>
                                    </ng-container> -->
                                </ng-container>
                                <ng-container *ngIf="!rule?.valuesJson">
                                    <ng-container *ngFor="let val of rule.values; let i = index;">
                                        <ng-container [ngSwitch]="rule?.dataType">
                                            <ng-container *ngSwitchCase="'DateTime'">
                                                <ng-container [ngSwitch]="rule?.equation">
                                                    <ng-container *ngSwitchCase="'Between'">
                                                        {{ val?.split('AND')?.[0] |
                                                        date:'MM/dd/yyyy'}} to {{
                                                        val?.split('AND')?.[1] | date:'MM/dd/yyyy'}}
                                                    </ng-container>
                                                    <ng-container *ngSwitchCase="'Is'">
                                                        <span *ngIf="val?.includes('-')">{{ val |
                                                            date:'MM/dd/yyyy'}}</span>
                                                    </ng-container>
                                                    <ng-container *ngSwitchCase="'Is'">
                                                        <span *ngIf="!val?.includes('-')">{{ val | ssDateTimeLabel }}</span>
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>
                                                        {{ val | date:'MM/dd/yyyy' }}
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'Time'">
                                                <span *ngIf="i==1" class="p-m-1">to</span>
                                                {{ val | onlyTime }}
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                {{i>0?',':''}} <ng-container *ngIf="!rule?.compareWithField">{{ rule?.equation == 'Between' &&
                                                val?.split('AND')?.[0] && val?.split('AND')?.[1] ?
                                                val?.split('AND')?.[0] + ' to ' +
                                                val?.split('AND')?.[1] : val }}</ng-container><ng-container *ngIf="rule?.compareWithField"> {{ rule?.comparisonCriteriaParentLabel ? rule?.comparisonCriteriaParentLabel + ': ' : '' }}{{ rule?.comparisonCriteriaLabel }}</ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="rule?.equation == 'HasValue'">
                                        <span>Any</span>
                                    </ng-container>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                <div *ngIf="selectedSearch?.isCombinational" class="combine-rules-wrapper">
                    <h6 class="combine-rules-header">
                        Added Rules Combination
                    </h6>
                    <div class="p-grid p-mt-2">
                        <div class="p-col-8">
                            <strong class="p-ml-3">{{ selectedSearch?.ruleCombination | ssCombineRulesView:selectedSearch?.savedSearchRuleRequest }}</strong>
                        </div>
                    </div>
                </div>
           </div>
       </div>
   </div>
   <p-footer>
       <button type="button" pButton (click)="dialogClose()" label="Cancel" class="p-button-secondary"></button>
       <button type="submit" pButton label="Save" (click)="saveSavedSearchRule()" [disabled]="!selectedSearch"></button>
   </p-footer>
</p-dialog>
